export var ShiftFlowModalContentTypes;
(function (ShiftFlowModalContentTypes) {
    ShiftFlowModalContentTypes["detail"] = "detail";
    ShiftFlowModalContentTypes["drop"] = "drop";
    ShiftFlowModalContentTypes["dropSuccess"] = "dropSuccess";
    ShiftFlowModalContentTypes["confirmDrop"] = "confirmDrop";
    ShiftFlowModalContentTypes["dropMultipleShifts"] = "dropMultipleShifts";
    ShiftFlowModalContentTypes["dropError"] = "dropError";
    ShiftFlowModalContentTypes["vtoAccept"] = "vtoAccept";
    ShiftFlowModalContentTypes["vtoSelect"] = "vtoSelect";
    ShiftFlowModalContentTypes["vtoSuccess"] = "vtoSuccess";
    ShiftFlowModalContentTypes["vtoError"] = "vtoError";
    ShiftFlowModalContentTypes["swapCancel"] = "swapCancel";
    ShiftFlowModalContentTypes["swapCancelSuccess"] = "swapCancelSuccess";
    ShiftFlowModalContentTypes["swapCancelError"] = "swapCancelError";
})(ShiftFlowModalContentTypes || (ShiftFlowModalContentTypes = {}));
export var ShiftFlowModalFeatureButtonType;
(function (ShiftFlowModalFeatureButtonType) {
    ShiftFlowModalFeatureButtonType["details"] = "details";
    ShiftFlowModalFeatureButtonType["options"] = "options";
})(ShiftFlowModalFeatureButtonType || (ShiftFlowModalFeatureButtonType = {}));
